export type AssetExplorerView = 'grid' | 'list';
export type AssetTypeFilter = 'all' | 'images' | 'fonts';

export const ASSET_EXPLORER_VIEW_KEY = 'phq.asset-explorer.view.v1';
export const ASSET_EXPLORER_TYPE_KEY = 'phq.asset-explorer.type.v1';

export function readAssetExplorerView(storage: Pick<Storage, 'getItem'> | undefined): AssetExplorerView {
  if (!storage) return 'grid';
  try {
    const value = storage.getItem(ASSET_EXPLORER_VIEW_KEY);
    return value === 'grid' || value === 'list' ? value : 'grid';
  } catch {
    return 'grid';
  }
}

export function writeAssetExplorerView(
  storage: Pick<Storage, 'setItem'> | undefined,
  value: AssetExplorerView
): void {
  try {
    storage?.setItem(ASSET_EXPLORER_VIEW_KEY, value);
  } catch {
    // Ponytail: an ergonomic preference cannot block the library.
  }
}

export function readAssetTypeFilter(storage: Pick<Storage, 'getItem'> | undefined): AssetTypeFilter {
  try {
    const value = storage?.getItem(ASSET_EXPLORER_TYPE_KEY);
    return value === 'images' || value === 'fonts' ? value : 'all';
  } catch { return 'all'; }
}

export function writeAssetTypeFilter(storage: Pick<Storage, 'setItem'> | undefined, value: AssetTypeFilter): void {
  try { storage?.setItem(ASSET_EXPLORER_TYPE_KEY, value); } catch { /* preference writes are best effort */ }
}

export function browserAssetExplorerStorage(): Storage | undefined {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
}
